import {
  type ChatResponse,
  type ChatSummary,
  type ChatTimeSeriesData,
  type ChannelData,
  type ComparedValue
} from '../models/chat'
import { type ChatChannelEntity, type ChatTotalsEntity } from '../../data/entities/chat.entity'
import { ComparedValueEntity } from '../../data/entities/media.entity'

export class CombinedChatToResponseMapper {
  public map(data: { channels: ChatChannelEntity[]; totals: ChatTotalsEntity }): ChatResponse {
    const summary: ChatSummary = {
      messages: this.mapComparedValue(data.totals.messages),
      activeUsers: this.mapComparedValue(data.totals.active_users),
      uniqueChatters: this.mapComparedValue(data.totals.unique_chatters)
    }

    const timeSeries: ChatTimeSeriesData[] = data.totals.periods.map((period) => ({
      date: period.date,
      messages: period.messages,
      activeUsers: period.active_users,
      uniqueChatters: period.unique_chatters
    }))

    const channels: ChannelData[] = data.channels.map((item) => ({
      name: item.name,
      messages: this.mapComparedValue(item.messages),
      activeUsers: this.mapComparedValue(item.active_users),
      uniqueChatters: this.mapComparedValue(item.unique_chatters)
    }))

    return {
      summary,
      timeSeries,
      channels
    }
  }

  private mapComparedValue(from: ComparedValueEntity): ComparedValue {
    return {
      current: from.current,
      previous: from.previous,
      diff: from.diff
    }
  }
}
